export const config = {
  autoRefresh: { value: true },
  dueSoon: { value: 24, required: true },
  keyboardShortcuts: { value: true },
  selectedLanguage: { value: '', required: true },
  drawerOption : {value : false},
  viewType: { value: "COMFORTABLE" }
};
